import AllhomesSearchFeaturedProperty, { BaseAllhomesSearchFeaturedProperty } from './allhomes-search-featured-property';
export default AllhomesSearchFeaturedProperty;
export { BaseAllhomesSearchFeaturedProperty };